/* eslint-disable */
import React from 'react';
// import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function DigitalBanner() {
    
    return (
        <>

        <div className="banner">
            <img
                src='../../assets/images/Social.jpg'
                alt="Digital Marketing and Social Media Services - ConnectMyVA"
                    title="SEO, SEM & Social Media Solutions for Businesses - ConnectMyVA"
                className="bannerImage"
            />			
        </div>
            

        </>
    )
}

export default DigitalBanner
